/**
 * Performance view configuration constants
 */

/**
 * Mapping of GeoJSON URLs to display names
 */
export const MODEL_DISPLAY_NAMES = {
  "VALIDATION_PLAN_v2:EU_025_historical_view": "AI Model 025",
  "VALIDATION_PLAN_v2:EU_0125_historical_view": "AI Model 0125",
};

/**
 * Mapping of models to their corresponding metrics names
 */
export const METRICS_NAMES = {
  "VALIDATION_PLAN_v2:EU_025_historical_view": "METRICAS_EU_025",
  "VALIDATION_PLAN_v2:EU_0125_historical_view": "METRICAS_EU_0125",
};

/**
 * Risk severity levels
 */
export const RISK_LEVELS = {
  OVERSHOOT: 'Overshoot',
  LIGHT: 'Light',
  SEVERE: 'Severe',
  MODERATE: 'Moderate',
  LIGHTNING: 'Lightning',
};

/**
 * Default values for the performance view
 */
export const DEFAULT_VALUES = {
  CQL_SEVERE: 'Light',
  CQL_FECHA: '2024-07-30 00:00:00',
  MAP_LEFT_LAYER: 'VALIDATION_PLAN_v2:EU_0125_historical_view',
  SELECTED_MODEL: 'VALIDATION_PLAN_v2:EU_0125_historical_view',
  TAB_INDEX: 0,
};

/**
 * Gets the right layer based on left layer and severity
 * @param {string} leftLayer - The selected left map layer
 * @param {string} severity - The selected severity level
 * @returns {string} - The corresponding right layer
 */
export const getRightLayer = (leftLayer, severity) => {
  const layerMappings = {
    'VALIDATION_PLAN_v2:EU_025_historical_view': {
      [RISK_LEVELS.OVERSHOOT]: 'TARGETS_OT:ot_EU_025_view',
      [RISK_LEVELS.LIGHT]: 'TARGETS_RDT:rdt_EU_025_view',
      [RISK_LEVELS.SEVERE]: 'TARGETS_RDT:rdt_EU_025_view',
      [RISK_LEVELS.MODERATE]: 'TARGETS_RDT:rdt_EU_025_view',
      [RISK_LEVELS.LIGHTNING]: 'TARGETS_LIGHTNINGS:lightnings_EU_025_view',
    },
    'VALIDATION_PLAN_v2:EU_0125_historical_view': {
      [RISK_LEVELS.OVERSHOOT]: 'TARGETS_OT:ot_EU_0125_view',
      [RISK_LEVELS.LIGHT]: 'TARGETS_RDT:rdt_EU_0125_view',
      [RISK_LEVELS.SEVERE]: 'TARGETS_RDT:rdt_EU_0125_view',
      [RISK_LEVELS.MODERATE]: 'TARGETS_RDT:rdt_EU_0125_view',
      [RISK_LEVELS.LIGHTNING]: 'TARGETS_LIGHTNINGS:lightnings_EU_0125_view',
    },
  };

  return layerMappings[leftLayer]?.[severity] || leftLayer;
};

/**
 * Gets the pretty display name for a model
 * @param {string} modelKey - The model key
 * @returns {string} - The display name
 */
export const getModelDisplayName = (modelKey) => {
  return MODEL_DISPLAY_NAMES[modelKey] || modelKey;
};

/**
 * Gets the metrics name for a model
 * @param {string} modelKey - The model key
 * @returns {string} - The metrics name
 */
export const getMetricsName = (modelKey) => {
  return METRICS_NAMES[modelKey];
};
